import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsService } from 'src/app/services/constants.service';
import { PersistenceService } from 'src/app/services/persistence.service';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    standalone: false
})
export class TimeoutComponent implements OnInit {

  attendee;

  constructor(
    private router: Router,
    private persistenceService: PersistenceService,
    private registrationService: RegistrationService,
    private constantsService: ConstantsService,
  ){

    }

  ngOnInit(): void {
  }

  forward(){
    this.attendee = this.registrationService.getAttendee({});
    this.persistenceService.clear();
    if(this.constantsService.paxLoginREDIRECTION.includes(this.attendee.PAXTypeNo)){
      this.router.navigate(['/login']);
    }else{
      this.router.navigate(['/instructions']);  
    }
  }

}
